import React from 'react';
import styled from 'types/theme.types';

const ColorText: React.FC<{ text: string; colorText: string }> = ({ text, colorText }) => {
  if (!text || !colorText) return <>{text}</>;

  const index = text.toLowerCase().indexOf(colorText.toLowerCase());
  if (index === -1) return <>{text}</>;

  const beforeStr = text.substring(0, index);
  const middleStr = text.substring(index, index + colorText.length);
  const afterStr = text.slice(index + colorText.length);
  return (
    <>
      {beforeStr}
      <StyledText>{middleStr}</StyledText>
      {afterStr}
    </>
  );
};

const StyledText = styled.span`
  color: red;
`;

export default ColorText;
